<template>
  <section>
    <table class="table is-striped" v-if="fieldPayload.currencies.data.length">
      <thead>
        <th>Wallet</th>
        <th>Merchant Key</th>
        <th>Merchant Code</th>
      </thead>
      <tbody>
        <tr v-for="currency in fieldPayload.currencies.data" :key="currency">
          <td>{{ currency }}</td>
          <td><b-input v-model="value[currency].merchantKey.data" /></td>
          <td><b-input v-model="value[currency].merchantCode.data" /></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: 'payment-paysec-currencies-wallets',
  props: ['value', 'fieldErrors', 'fieldPayload'],
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/PaymentPaysecCurrenciesWallets.vue